import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";          // ← switched library
import { apiInstance } from "../config/apiConfig";

export default function ResetPassword() {
  const nav = useNavigate();
  const { state } = useLocation();         // email passed from ForgotPassword
  const emailId   = state?.emailId;        // undefined if user came directly

  const [password, setPassword] = useState("");
  const [confirm,  setConfirm]  = useState("");
  const [loading,  setLoading]  = useState(false);

  /* redirect if no e-mail in nav state */
  useEffect(() => {
    if (!emailId) nav("/forgotpassword");
  }, [emailId, nav]);

  /* submit new password */
  const handleSubmit = async () => {
    if (password.length < 6)
      return toast.error("Password must be at least 6 characters");
    if (password !== confirm)
      return toast.error("Passwords do not match");

    setLoading(true);
    try {
      await toast.promise(
        apiInstance.post("/api/otp/reset-password", { emailId, password }),
        {
          loading : "Updating password…",
          success : "Password updated — you can log in now",
          error   : err => err?.response?.data?.message || "Reset failed",
        }
      );
      nav("/login");
    } finally {
      setLoading(false);
    }
  };

  /* UI */
  return (
    <section id="body">
      <div className="flex justify-center items-center h-screen">
        <div className="card w-96 bg-base-100 shadow-xl p-5">
          <div className="card-body">
            <h2 className="text-xl font-bold mb-4">Set new password</h2>

            <input
              type="password"
              className="input input-bordered mb-3"
              placeholder="New password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <input
              type="password"
              className="input input-bordered mb-6"
              placeholder="Confirm password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
            />

            <button
              className="secondary-button w-full"
              disabled={loading}
              onClick={handleSubmit}
            >
              Save&nbsp;
              {loading && <span className="loading loading-spinner" />}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
